import React from 'react'
import {
    StyledPromoCard,
    StyledPromoImg,
    StyledPromoLink,
} from '../PromoCard.styled'

export const SportsMasterclassPromoCard = () => {
    const promo = require('../assets/sports-masterclass.jpg')

    return (
        <StyledPromoCard promotion="sports-masterclass">
            <StyledPromoLink to="/features/sports-masterclass#latest-sporting-news">
                <StyledPromoImg
                    src={promo}
                    alt="Sports Masterclass Promo Banner"
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}
